import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ToolsService } from '@modules/tools/services';

@Component({
  selector: 'mg-tools-my-tools',
  templateUrl: './tools-my-tools.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolsMyToolsComponent {
  public toolType$ = this._toolsService.toolType$;
  constructor(private _toolsService: ToolsService) {}
}
